import { Pipe, PipeTransform } from "@angular/core";
import { AbstractControl, UntypedFormGroup } from "@angular/forms";

/**
 * Return form control from FormGroup
 */
@Pipe({
  name: "formControl",
  standalone: true,
})
export class FormControlPipe implements PipeTransform {
  transform(value: UntypedFormGroup, name: string): AbstractControl | null {
    return (value && value.controls[name]) || null;
  }
}
